module.exports = __webpack_public_path__ + "img/i_media_tracker-1.cbc16d80.png";